import { ethers } from "ethers";
import { getMarketplaceContract, getAuctionContract } from "./IgetContracts";
import Web3 from "web3";
import BigNumber from "bignumber.js";

export const BuyOutNFT = async (
  itemId: number,
  price: number,
  signer: ethers.Signer
) => {
  const NFTMarketplacecontract = getMarketplaceContract(signer);

  const tx = await NFTMarketplacecontract.connect(signer).createMarketSale(
    itemId,
    { value: price }
  );
  const receipt = await tx.wait();

  if (receipt.status === 1) {
    return {
      success: true,
      message: " Successful!",
    };
  }

  return {
    success: false,
    message: " Failed!",
  };
};

export const getTheRoundTimeRemaining = async () => {
  try {
    const AUCTIONCONTRACT = getAuctionContract();

    //const quote = await AUCTIONCONTRACT.timeRemaining();
    const quote = 100000;
    // Return the quote
    return quote;
  } catch (e) {
    console.log(e);
  }
};
